// extracted by mini-css-extract-plugin
module.exports = {"controls":"IssueVideoList_controls__EEC0S","videoWrapper":"IssueVideoList_videoWrapper__2mSYz","deleted":"IssueVideoList_deleted__1r3_n","video":"IssueVideoList_video__2875z"};